import React from "react";
import PropTypes from "prop-types";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIAutoComplete from "@mui/material/Autocomplete";
import MUIGrid from "@mui/material/Grid";
import MainContext from "../../../../Context/MainContext/MainContext";
import MUITypography from "@mui/material/Typography";
import Format from "../../../../Utility/Format";

export default class CardAdminLocationContact extends CardClass {
  constructor(props) {
    super(props);
  }

  static contextType = MainContext; // For legacy class components

  /**
   * Render the content of the card.
   */
  renderContent() {
    const getStateListOptions = () => {
      let stateOptions = [];
      this.context.stateSalesTax.forEach((state) => {
        stateOptions.push({
          label: state.name + " - " + state.abbr,
          value: state.abbr,
        });
      });
      return stateOptions;
    };

    const handlePhoneNumberChange = (event, field) => {
      const { value } = event.target;
      const digits = value.replace(/\D/g, "").slice(0, 10);
      this.props.onChange({ [field]: digits ? digits : null });
    };

    const timeZones = Object.values(this.context.termsIndexed).filter(
      (term) => term.type === "time_zone",
    );

    return (
      <>
        <MUITypography variant="subtitle1" style={{ marginBottom: 20 }}>
          Address
        </MUITypography>
        <MUIGrid container spacing={2}>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={
                this.props.location && this.props.location.address
                  ? this.props.location.address
                  : ""
              }
              size="small"
              label="Address"
              variant="standard"
              fullWidth={true}
              inputProps={{
                maxLength: 255,
              }}
              InputLabelProps={{ shrink: true }}
              onBlur={(e) =>
                this.props.onChange({ address: e.target.value.trim() })
              }
              onChange={(e) => this.props.onChange({ address: e.target.value })}
              required={true}
              error={this.props.validationIssues.address ? true : false}
              helperText={
                this.props.validationIssues.address
                  ? this.props.validationIssues.address
                  : ""
              }
            />
          </MUIGrid>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={
                this.props.location && this.props.location.city
                  ? this.props.location.city
                  : ""
              }
              size="small"
              label="City"
              variant="standard"
              fullWidth={true}
              inputProps={{
                maxLength: 255,
              }}
              InputLabelProps={{ shrink: true }}
              onBlur={(e) =>
                this.props.onChange({ city: e.target.value.trim() })
              }
              onChange={(e) => this.props.onChange({ city: e.target.value })}
              required={true}
              error={this.props.validationIssues.city ? true : false}
              helperText={
                this.props.validationIssues.city
                  ? this.props.validationIssues.city
                  : ""
              }
            />
          </MUIGrid>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUIAutoComplete
              options={getStateListOptions()}
              value={
                this.props.location
                  ? getStateListOptions().find(
                      (option) => option.value === this.props.location.state,
                    ) || null
                  : null
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(e, value) =>
                this.props.onChange({ state: value ? value.value : null })
              }
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="standard"
                  label="State"
                  required={true}
                  fullWidth
                  error={
                    this.props.validationIssues &&
                    this.props.validationIssues.state
                      ? true
                      : false
                  }
                  helperText={
                    this.props.validationIssues
                      ? this.props.validationIssues.state
                      : ""
                  }
                />
              )}
            />
          </MUIGrid>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={
                this.props.location && this.props.location.zipCode
                  ? this.props.location.zipCode
                  : ""
              }
              size="small"
              label="Postal Code"
              variant="standard"
              fullWidth={true}
              inputProps={{
                maxLength: 5,
                inputMode: "numeric", // Show numeric keyboard
              }}
              InputLabelProps={{ shrink: true }}
              onBlur={(e) =>
                this.props.onChange({ zipCode: e.target.value.trim() })
              }
              onChange={(e) => {
                // Allow only digits
                const value = e.target.value.replace(/[^0-9]/g, "");
                this.props.onChange({ zipCode: value });
              }}
              required={true}
              error={this.props.validationIssues.zipCode ? true : false}
              helperText={
                this.props.validationIssues.zipCode
                  ? this.props.validationIssues.zipCode
                  : ""
              }
            />
          </MUIGrid>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUIAutoComplete
              options={timeZones}
              value={
                timeZones.find(
                  (term) => term.id === this.props.location?.timeZoneTermId,
                ) || null
              }
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => option?.name || ""}
              onChange={(e, newValue) => {
                this.props.onChange({
                  timeZoneTermId: newValue ? newValue.id : null,
                });
              }}
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="standard"
                  label="Time Zone"
                  fullWidth
                  required={true}
                  error={
                    this.props.validationIssues &&
                    this.props.validationIssues.timeZoneTermId
                      ? true
                      : false
                  }
                  helperText={
                    this.props.validationIssues
                      ? this.props.validationIssues.timeZoneTermId
                      : ""
                  }
                />
              )}
            />
          </MUIGrid>
        </MUIGrid>
        <MUITypography
          variant="subtitle1"
          style={{ marginTop: 20, marginBottom: 20 }}
        >
          Phone Numbers
        </MUITypography>
        <MUIGrid container spacing={2}>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={
                this.props.location
                  ? Format.phone(this.props.location.salesPhone)
                  : ""
              }
              size="small"
              label="Sales Phone"
              variant="standard"
              fullWidth={true}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handlePhoneNumberChange(e, "salesPhone")}
              required={true}
              error={
                this.props.validationIssues &&
                this.props.validationIssues.salesPhone
                  ? true
                  : false
              }
              helperText={
                this.props.validationIssues &&
                this.props.validationIssues.salesPhone
                  ? this.props.validationIssues.salesPhone
                  : ""
              }
            />
          </MUIGrid>
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={
                this.props.location
                  ? Format.phone(this.props.location.fieldOperationsPhone)
                  : ""
              }
              size="small"
              label="Field Operations Phone"
              variant="standard"
              fullWidth={true}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handlePhoneNumberChange(e, "fieldOperationsPhone")
              }
              required={true}
              error={
                this.props.validationIssues &&
                this.props.validationIssues.fieldOperationsPhone
                  ? true
                  : false
              }
              helperText={
                this.props.validationIssues &&
                this.props.validationIssues.fieldOperationsPhone
                  ? this.props.validationIssues.fieldOperationsPhone
                  : ""
              }
            />
          </MUIGrid>
        </MUIGrid>
      </>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Contact";
  }
}
